/**
 * Application configuration
 * Uses environment variables for different deployment environments
 */

// API URL - defaults to localhost for development
export const API_URL = (import.meta.env.VITE_API_URL as string) || 'http://localhost:8001';

// Dev server URL for live preview iframe (Vite dev server on VPS)
export const DEV_SERVER_URL = (import.meta.env.VITE_DEV_SERVER_URL as string) || '';

// Environment
export const IS_PRODUCTION = import.meta.env.PROD as boolean;
export const IS_DEVELOPMENT = import.meta.env.DEV as boolean;

// Feature flags
export const FEATURES = {
  enableAnalytics: IS_PRODUCTION,
  enableDebugMode: IS_DEVELOPMENT,
  enableDevPreview: !!DEV_SERVER_URL,
};

// API endpoints
export const API_ENDPOINTS = {
  tasks: `${API_URL}/tasks`,
  projects: `${API_URL}/projects`,
  habits: `${API_URL}/habits`,
  tracking: `${API_URL}/tracking`,
  dashboard: `${API_URL}/api/layout`,
  deepWork: `${API_URL}/deep-work`,
  agenda: `${API_URL}/api/agenda`,
  actions: `${API_URL}/api/actions`,
  agents: `${API_URL}/api/agents`,
  chat: `${API_URL}/api/chat`,
  proxmox: `${API_URL}/api/infrastructure/proxmox`,
};

export default {
  API_URL,
  IS_PRODUCTION,
  IS_DEVELOPMENT,
  FEATURES,
  API_ENDPOINTS,
};
